import { C, IMG_COLORS, IMG_LABELS } from "../data/constants";

const HEIGHTS = [160,200,240,180,220,170,200,240,160,200,180,220,160,240,200,180,160,220,200,240];

export default function Gallery() {
  return (
    <section id="gallery" style={{ padding: "100px 40px", background: C.linen }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>

        <div className="fade" style={{ textAlign: "center", marginBottom: 50 }}>
          <p style={{ color: C.blush, letterSpacing: 3, textTransform: "uppercase", fontSize: 12, marginBottom: 12 }}>Our Work</p>
          <h2 style={{ fontSize: 48, fontWeight: 300, color: C.dark }}>Portfolio Gallery</h2>
          <div style={{ width: 60, height: 1, background: C.blush, margin: "20px auto 30px" }} />
          <p style={{ color: C.mid, maxWidth: 540, margin: "0 auto", lineHeight: 1.8 }}>
            A glimpse of real events we've delivered — every photo below represents a moment made unforgettable.
          </p>
        </div>

        {/* Masonry grid */}
        <div style={{ columns: "280px 4", gap: 14 }}>
          {IMG_LABELS.map((label, i) => (
            <div key={i} className="fade lift" style={{ breakInside: "avoid", marginBottom: 14, borderRadius: 12, overflow: "hidden" }}>
              <div style={{
                background: IMG_COLORS[i],
                height: HEIGHTS[i],
                display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                color: "rgba(255,255,255,0.8)", textAlign: "center", padding: 12,
              }}>
                <div style={{ fontSize: 24, marginBottom: 6 }}>📸</div>
                <div style={{ fontSize: 11, letterSpacing: 0.5 }}>{label}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="fade" style={{ textAlign: "center", marginTop: 36 }}>
          <p style={{ color: C.slate, fontSize: 13, fontStyle: "italic" }}>

          </p>
        </div>
      </div>
    </section>
  );
}
